import Layout from "../views/layout/Layout";

export default {
    path: '/finance',
    component: Layout,
    redirect: '/finance/withdraw',
    meta: {title: '财务管理', icon: 'el-icon-wallet'},
    children: [{
        path: 'withdraw',
        name: 'withdraw',
        component: () => import('@/views/finance/withdraw/index'),
        meta: {title: '提现管理', icon: 'product-cate'},
        auth: 'finance:withdraw'
    }, {
        path: 'bill',
        name: 'bill',
        component: () => import('@/views/finance/bill/index'),
        meta: {title: '订单流水', icon: 'product-cate'},
        auth: 'finance:bill'
    }, {
        path: 'agentBill',
        name: 'agentBill',
        component: () => import('@/views/finance/agentBill/index'),
        meta: {title: '代理商账单', icon: 'product-cate'},
        auth: 'finance:agentBill'
    }, {
        path: 'cashRecord',
        name: 'cashRecord',
        component: () => import('@/views/finance/cashRecord/index'),
        meta: {title: '押金记录', icon: 'product-cate'},
        auth: 'finance:agentBill'
    }, {
        path: 'platformAccount',
        name: 'platformAccount',
        component: () => import('@/views/finance/platformAccount/index'),
        meta: {title: '平台账户余额', icon: 'product-cate'},
        auth: 'finance:platformAccount'
    }, {
        path: 'billRecord',
        name: 'billRecord',
        component: () => import('@/views/finance/billRecord/index'),
        meta: {title: '员工账单', icon: 'product-cate'},
        auth: 'finance:billRecord'
    }]
}



// WEBPACK FOOTER //
// ./src/router/finance.js